import { orderApi } from "../../order/orderApi";
import { refreshTableOrderOperation } from "../operations";

export const refreshTableOrder = () => refreshTableOrderOperation.getThunk(() => orderApi.invoke("refreshTableOrder"));
